import { useEffect, useRef } from "react";
import { Ban, Eye, Undo2 } from "lucide-react";

import { Action } from "../../../components/ui/Action";
import { CrmPetController } from "../../../services/controllers/crmPet";
import { useCrmPet } from "../../../store/crmPet/useCrmPet";
import { WhatsAppIcon } from "../icons/WhatsAppIcon";

const actionButtonClass = "!h-8 !w-8 !min-w-8 !max-w-8 !p-0 !shadow-sm";
const actionButtonStyle = {
  width: 32,
  height: 32,
  minWidth: 32,
  maxWidth: 32,
  padding: 0,
};

export function PetRowActions({ row }) {
  const CCrmPet = CrmPetController();
  const petBlocking = useCrmPet((state) => state.data.petBlocking);
  const marking = useCrmPet((state) => state.data.contactMarking[row.pet.petId]);
  const checkbox = useRef(null);
  useEffect(() => { if (checkbox.current) checkbox.current.indeterminate = row.contactSummary.partial === true; }, [row.contactSummary.partial]);
  const pet = row.pet;
  const BlockIcon = pet.blocked ? Undo2 : Ban;

  return (
    <div className="flex w-full items-center justify-end gap-2">
      <input
        ref={checkbox}
        type="checkbox"
        aria-label={`Contato feito para ${pet.petName}`}
        title="Contato feito — válido por 7 dias"
        checked={row.contactSummary.status === "CONTACTED"}
        disabled={marking || !row.customerId || !row.memberships.length || (pet.blocked && row.contactSummary.status !== "CONTACTED" && !row.contactSummary.partial)}
        onChange={(event) => CCrmPet.setRowContactStatus(row, pet.blocked ? false : event.target.checked)}
        className="h-4 w-4 accent-scale-500"
      />
      <Action.Root
        status="success"
        type="button"
        title="Abrir WhatsApp"
        disabled={!row.customerPhone || pet.blocked || !row.customerId}
        name={`open-whatsapp-${row.rowKey}`}
        className={actionButtonClass}
        style={actionButtonStyle}
        onClick={() => CCrmPet.openWhatsApp(row.customerKey)}
      >
        <Action.Icon icon={WhatsAppIcon} size={16} />
      </Action.Root>
      <Action.Root
        outline
        status={pet.blocked ? "warning" : "danger"}
        type="button"
        title={pet.blocked ? `Desbloquear ${pet.petName}` : `Bloquear ${pet.petName}`}
        disabled={petBlocking[pet.petId]}
        name={`toggle-block-${row.rowKey}`}
        className={actionButtonClass}
        style={actionButtonStyle}
        onClick={() => CCrmPet.toggleBlocked(pet)}
      >
        <Action.Icon icon={BlockIcon} isLoading={petBlocking[pet.petId]} size={16} />
      </Action.Root>
      <Action.Root
        status="400"
        type="button"
        title="Ver histórico de contatos"
        name={`see-contact-history-${row.rowKey}`}
        aria-label={`Ver histórico de contatos de ${row.customerName}`}
        className={actionButtonClass}
        style={actionButtonStyle}
        onClick={() => CCrmPet.openContactHistory(row)}
      >
        <Action.Icon icon={Eye} size={16} />
      </Action.Root>
    </div>
  );
}
